"use strict";import{FieldGroup as e}from"./src/FieldGroup.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-field-group",e);
//# sourceMappingURL=sp-field-group.js.map
